import { render, staticRenderFns } from "./CardViews.vue?vue&type=template&id=5abb1ee2&scoped=true&"
import script from "./CardViews.vue?vue&type=script&lang=js&"
export * from "./CardViews.vue?vue&type=script&lang=js&"
import style0 from "./CardViews.vue?vue&type=style&index=0&id=5abb1ee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb1ee2",
  null
  
)

export default component.exports